import React from "react";
import { FormattedMessage } from "react-intl";
import { Carousel, Tooltip } from "antd";
import "./reviews.scss";

import { Text } from "@ui-kit";
import { REVIEWS } from "./reviews.const";

const Reviews = () => {
  return (
    <div className="reviews__container">
      <div className="main__container reviews__content">
        <div className="reviews__header">
          <Text as="h1" className="mb-20">
            <FormattedMessage
              id="reviews.header.title"
              defaultMessage="Feedback from our users"
            />
          </Text>
          <Text as="h3">
            <FormattedMessage
              id="reviews.header.description"
              defaultMessage="We have selected over 10,000 effective keywords"
            />
          </Text>
        </div>
        <div className="reviews__items">
          <Carousel
            autoplay
            slidesToShow={2}
            arrows
            infinite={true}
            draggable={true}
          >
            {REVIEWS.map((item, index) => {
              return (
                <div className="reviews__item" key={`item-${index}`}>
                  <Text as="h5" className="mb-8">
                    <FormattedMessage
                      id={`reviews.item${index + 1}.translate`}
                      defaultMessage={item.translate}
                    />
                  </Text>
                  <Tooltip
                    title={
                      <FormattedMessage
                        id={`reviews.item${index + 1}.description`}
                        defaultMessage={item.text}
                      />
                    }
                  >
                    <>
                      <Text as="h4" className="mb-8">
                        "
                        <FormattedMessage
                          id={`reviews.item${index + 1}.description`}
                          defaultMessage={item.text}
                        />
                        "
                      </Text>
                    </>
                  </Tooltip>
                  <div className="user-info">
                    <Text as="h5" className="author__name">
                      {item.user.name}
                    </Text>
                    <Text as="h5" className="author__text">
                      <FormattedMessage
                        id={`reviews.item${index + 1}.user.role`}
                        defaultMessage={item.user.role}
                      />
                    </Text>
                  </div>
                </div>
              );
            })}
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
